import { ServiceResponse } from './../models/ServiceResponse';
import type { TicketsUser } from "@/types/TicketsUser"
import { api } from '@/services/Api'
import { authenticationService } from '@/services/AuthenticationService'
import { reactive } from 'vue'

const state = reactive<{ user: TicketsUser | null }>({ user: null })

class UserService {

  public get user(): TicketsUser | null {
    return state.user
  }

  public async loadUser(): Promise<ServiceResponse<TicketsUser | null>> {
    const response = await api.get<TicketsUser>('api/user')
    state.user = response.success ? response.data : null
    return new ServiceResponse(response, response.data)
  }

  public isLoggedIn(): boolean {
    return !!this.user?.userName
  }

  public isGameEditor(filename: string): boolean {
    if (!this.user?.isEditor) {
      return false
    }
    const hasSeatsForFile = this.user.seats.filter(s => filename.indexOf(s.stadium) === 0)
    return hasSeatsForFile.length > 0
  }

  public isSeatOwner(filename: string, seatId: string): boolean {
    if (!this.user?.isEditor) {
      return false
    }
    const ownedSeats = this.user.seats.filter(s =>
      s.id === seatId && filename.indexOf(s.stadium) === 0)
    return ownedSeats.length > 0
  }

  public async login(): Promise<void> {
    await authenticationService.login()
  }

  public async logout(): Promise<void> {
    await authenticationService.logout()
  }
}

export const userService = new UserService()
